import { VirtualAvvenimentoInPartenza } from 'lib/api/virtual/virtualProssimePartenzeResponseApi';
import { VirtualTableRow } from '../../virtualTableRow';

export type VirtualProssimePartenzeProps = {
  avvenimentoList: Array<VirtualAvvenimentoInPartenza> | undefined;
  children?: React.ReactNode;
};
export const VirtualProssimePartenzeList = ({ avvenimentoList, children }: VirtualProssimePartenzeProps) => {
  return (
    !!avvenimentoList?.length &&
    avvenimentoList.map((avvenimento: VirtualAvvenimentoInPartenza, index) => {
      return (
        <VirtualTableRow key={`${avvenimento}_${index}`} {...avvenimento} hasHeader hasShowMore>
          {children && children}
        </VirtualTableRow>
      );
    })
  );
};
